"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _acceptNotificationHandler = require("./acceptNotificationHandler");
Object.keys(_acceptNotificationHandler).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _acceptNotificationHandler[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _acceptNotificationHandler[key];
    }
  });
});
var _addBackorderDemandHandler = require("./addBackorderDemandHandler");
Object.keys(_addBackorderDemandHandler).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _addBackorderDemandHandler[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _addBackorderDemandHandler[key];
    }
  });
});
var _addBasketOfferHandler = require("./addBasketOfferHandler");
Object.keys(_addBasketOfferHandler).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _addBasketOfferHandler[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _addBasketOfferHandler[key];
    }
  });
});
var _addCatalogueOfferHandler = require("./addCatalogueOfferHandler");
Object.keys(_addCatalogueOfferHandler).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _addCatalogueOfferHandler[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _addCatalogueOfferHandler[key];
    }
  });
});
var _addCustomerOrderHandler = require("./addCustomerOrderHandler");
Object.keys(_addCustomerOrderHandler).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _addCustomerOrderHandler[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _addCustomerOrderHandler[key];
    }
  });
});
var _addFreeShippingOfferHandler = require("./addFreeShippingOfferHandler");
Object.keys(_addFreeShippingOfferHandler).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _addFreeShippingOfferHandler[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _addFreeShippingOfferHandler[key];
    }
  });
});
var _addPersonalNutritionItemsHandler = require("./addPersonalNutritionItemsHandler");
Object.keys(_addPersonalNutritionItemsHandler).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _addPersonalNutritionItemsHandler[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _addPersonalNutritionItemsHandler[key];
    }
  });
});
var _addPersonalSubscriptionHandler = require("./addPersonalSubscriptionHandler");
Object.keys(_addPersonalSubscriptionHandler).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _addPersonalSubscriptionHandler[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _addPersonalSubscriptionHandler[key];
    }
  });
});
var _addToBasketHandler = require("./addToBasketHandler");
Object.keys(_addToBasketHandler).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _addToBasketHandler[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _addToBasketHandler[key];
    }
  });
});
var _addVoucherHandler = require("./addVoucherHandler");
Object.keys(_addVoucherHandler).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _addVoucherHandler[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _addVoucherHandler[key];
    }
  });
});
var _cancelBackorderDemandHandler = require("./cancelBackorderDemandHandler");
Object.keys(_cancelBackorderDemandHandler).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _cancelBackorderDemandHandler[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _cancelBackorderDemandHandler[key];
    }
  });
});
var _cancelSubscriptionHandler = require("./cancelSubscriptionHandler");
Object.keys(_cancelSubscriptionHandler).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _cancelSubscriptionHandler[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _cancelSubscriptionHandler[key];
    }
  });
});
var _checkLoyaltyDialogResultAndAddToBasketHandler = require("./checkLoyaltyDialogResultAndAddToBasketHandler");
Object.keys(_checkLoyaltyDialogResultAndAddToBasketHandler).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _checkLoyaltyDialogResultAndAddToBasketHandler[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _checkLoyaltyDialogResultAndAddToBasketHandler[key];
    }
  });
});
var _clearBasketHandler = require("./clearBasketHandler");
Object.keys(_clearBasketHandler).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _clearBasketHandler[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _clearBasketHandler[key];
    }
  });
});
var _delaySubscriptionHandler = require("./delaySubscriptionHandler");
Object.keys(_delaySubscriptionHandler).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _delaySubscriptionHandler[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _delaySubscriptionHandler[key];
    }
  });
});
var _deleteOfferItemHandler = require("./deleteOfferItemHandler");
Object.keys(_deleteOfferItemHandler).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _deleteOfferItemHandler[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _deleteOfferItemHandler[key];
    }
  });
});
var _removeBasketItemHandler = require("./removeBasketItemHandler");
Object.keys(_removeBasketItemHandler).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _removeBasketItemHandler[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _removeBasketItemHandler[key];
    }
  });
});
var _removeCustomerOrderHandler = require("./removeCustomerOrderHandler");
Object.keys(_removeCustomerOrderHandler).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _removeCustomerOrderHandler[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _removeCustomerOrderHandler[key];
    }
  });
});
var _removeShippingOfferItemHandler = require("./removeShippingOfferItemHandler");
Object.keys(_removeShippingOfferItemHandler).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _removeShippingOfferItemHandler[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _removeShippingOfferItemHandler[key];
    }
  });
});
var _removeVoucherHandler = require("./removeVoucherHandler");
Object.keys(_removeVoucherHandler).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _removeVoucherHandler[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _removeVoucherHandler[key];
    }
  });
});
var _replaceShoppingBagItemHandler = require("./replaceShoppingBagItemHandler");
Object.keys(_replaceShoppingBagItemHandler).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _replaceShoppingBagItemHandler[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _replaceShoppingBagItemHandler[key];
    }
  });
});
var _replaceSubscriptionHandler = require("./replaceSubscriptionHandler");
Object.keys(_replaceSubscriptionHandler).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _replaceSubscriptionHandler[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _replaceSubscriptionHandler[key];
    }
  });
});
var _requestShoppingContextHandler = require("./requestShoppingContextHandler");
Object.keys(_requestShoppingContextHandler).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _requestShoppingContextHandler[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _requestShoppingContextHandler[key];
    }
  });
});
var _resetShippingSelectionHandler = require("./resetShippingSelectionHandler");
Object.keys(_resetShippingSelectionHandler).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _resetShippingSelectionHandler[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _resetShippingSelectionHandler[key];
    }
  });
});
var _updateBasketItemHandler = require("./updateBasketItemHandler");
Object.keys(_updateBasketItemHandler).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _updateBasketItemHandler[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _updateBasketItemHandler[key];
    }
  });
});
var _updateCustomerOrderItemHandler = require("./updateCustomerOrderItemHandler");
Object.keys(_updateCustomerOrderItemHandler).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _updateCustomerOrderItemHandler[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _updateCustomerOrderItemHandler[key];
    }
  });
});
var _updateDeliveryHandler = require("./updateDeliveryHandler");
Object.keys(_updateDeliveryHandler).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _updateDeliveryHandler[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _updateDeliveryHandler[key];
    }
  });
});
var _updateDeliveryChannelHandler = require("./updateDeliveryChannelHandler");
Object.keys(_updateDeliveryChannelHandler).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _updateDeliveryChannelHandler[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _updateDeliveryChannelHandler[key];
    }
  });
});
var _updateDonationHandler = require("./updateDonationHandler");
Object.keys(_updateDonationHandler).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _updateDonationHandler[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _updateDonationHandler[key];
    }
  });
});
var _updateOfferItemHandler = require("./updateOfferItemHandler");
Object.keys(_updateOfferItemHandler).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _updateOfferItemHandler[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _updateOfferItemHandler[key];
    }
  });
});
var _updateOfferItemsHandler = require("./updateOfferItemsHandler");
Object.keys(_updateOfferItemsHandler).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _updateOfferItemsHandler[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _updateOfferItemsHandler[key];
    }
  });
});
var _updatePaymentProviderHandler = require("./updatePaymentProviderHandler");
Object.keys(_updatePaymentProviderHandler).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _updatePaymentProviderHandler[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _updatePaymentProviderHandler[key];
    }
  });
});
